export const JWT_LOGIN_REQUEST = 'JWT_LOGIN_REQUEST';
export const JWT_LOGIN_SUCCESS = 'JWT_LOGIN_SUCCESS';
export const JWT_LOGIN_FAILURE = 'JWT_LOGIN_FAILURE';

